module.exports = __webpack_public_path__ + "img/logo-itserve.620e2766.jpg";